import { BookingProviders } from './bookingProviders';

export const TicketProviders = {
  LETS_DO_THIS: BookingProviders.DIRECT,
  EXTERNAL_GUEST_CHECKOUT: BookingProviders.TRACKING_ONLY,
  EVENTRAC: BookingProviders.EVENTRAC,
  CLUBTRAC: BookingProviders.CLUBTRAC,
  RUNSIGNUP: BookingProviders.RUNSIGNUP,
  UBIO_PROXY: BookingProviders.UBIO_PROXY,
};
